export interface UserSession {
  userSessionId: string;
  userId: string;
  refreshToken: string | undefined;
  expirationDate: Date;
  device: string;
  ipAddress: string;
  token: string;
}

export interface AuthenticatedAuthResponse {
  authenticationStatus: 'authenticated';
  userId: string;
  name: string;
  username: string;
  email: string;
  socialLoginUserId?: string;
  socialLoginProvider?: string;
  addedDate?: string;
  twoFactorEnabled?: boolean;
  stayLoggedInFor?: number;
  userSession: UserSession;
}

export interface TwoFactorRequiredAuthResponse {
  authenticationStatus: 'twoFactorRequired';
  challengeToken: string;
  expiresAt: string;
  maskedEmail: string;
  methods: Array<'authenticator' | 'email'>;
  serverTime: string;
}

export type AuthResponse = AuthenticatedAuthResponse | TwoFactorRequiredAuthResponse;

export function isAuthenticatedResponse(
  response: AuthResponse
): response is AuthenticatedAuthResponse {
  return response.authenticationStatus === 'authenticated';
}
